module.exports = __webpack_public_path__ + "img/Group2.ca7c1289.png";